import { getGraphQLErrorsAndNetworkError } from "@/lib/apollo-client/custom-error";
import type { MutationSideEffectHandler } from "@/lib/apollo-client/custom-mutation";
import { customMutation } from "@/lib/apollo-client/custom-mutation";

import { useGraphQLErrorsHandler, useNetworkErrorHandler } from "./_shared";

/**
 * mutation 実行のレスポンスに関する副作用をハンドリングする
 */
const useResponseSideEffectHandler: MutationSideEffectHandler = ({ error }) => {
	const { onHandleChillnnGraphQLErrors, onHandleNonChillnnGraphQLErrors } = useGraphQLErrorsHandler();
	const { onHandleNetworkError } = useNetworkErrorHandler();

	if (!error) return;

	/**
	 * graphQLErrors と networkError を確定する
	 * （constraint 違反など HTTP body 側にだけ errors が載る場合がある）
	 */
	const { graphQLErrors, networkError } = getGraphQLErrorsAndNetworkError(error);
	/**
	 * Chillnn で定義された GraphQL Errors のハンドリングを行う
	 */
	onHandleChillnnGraphQLErrors(graphQLErrors);
	/**
	 * Chillnn で定義されていない GraphQL Errors のハンドリングを行う
	 */
	onHandleNonChillnnGraphQLErrors(graphQLErrors, {
		title: "エラーが発生しました",
		description: "時間をおいて再度お試しください。",
	});

	if (networkError) {
		onHandleNetworkError(networkError, {
			title: "ネットワークエラーが発生しました",
			description: "使用されている通信環境をご確認の上再度お試しください。",
		});
	}
};

export const useCustomMutation = customMutation(useResponseSideEffectHandler);
